// extracted by mini-css-extract-plugin
export default {"container":"ChatInput_container__ok-4D","input":"ChatInput_input__2yECz","button":"ChatInput_button__nq3gp"};